import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../../../../store/reducers';
import { Website } from '../../../../../../mymail/models/website.model';

@Component({
  selector: 'mprd-manage-your-websites',
  templateUrl: './manage-your-websites.component.html',
})
export class ManageYourWebsitesComponent implements OnInit {
  @Input() productDetails: any;
  websites: Website[] = [];
  @Output() selectWebsite: EventEmitter<string> = new EventEmitter();

  constructor(private store: Store<ApplicationState>) {}

  ngOnInit(): void {
    const website: Website = {
      accessNumber: this.productDetails.digitalisProductDetails.accessNumber,
      productDescription:
        this.productDetails.digitalisProductDetails.productDescription,
    };

    this.websites.push(website);
    this.productDetails.productIdentifiers
      .filter(
        (productIdentifier) =>
          productIdentifier.accessNumber !==
          this.productDetails.digitalisProductDetails.accessNumber,
      )
      .forEach((productIdentifier) => {
        const productIdentifiersWebsite: Website = {
          accessNumber: productIdentifier.accessNumber,
          productDescription: productIdentifier.productDescription,
        };
        this.websites.push(productIdentifiersWebsite);
      });
  }

  onSelectWebsite(accessNumber) {
    this.selectWebsite.emit(accessNumber);
  }
}
